// extracted by mini-css-extract-plugin
export default {"errorServer":"errorServer_errorServer__V1f3o"};